import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { useState } from "react";
import GeneralSettings from "./components/generalSettings";

const SettingsPage: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    return (
        <div className="container-fluid py-3">
            <div className="d-flex flex-column gap-2 mb-3">
                <h2 className="h4 mb-0">Settings</h2>
                <p className="text-muted mb-0">Configure your workspace and administrative preferences.</p>
            </div>
            <TabStrip
                selected={selectedTab}
                onSelect={event => setSelectedTab(event.selected)}
                className="bg-white rounded-3 border border-secondary-subtle"
            >
                <TabStripTab title="General">
                    <GeneralSettings />
                </TabStripTab>
            </TabStrip>
        </div>
    );
};

export default SettingsPage;
